module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggc3R5bGU9ImZpbGw6bm9uZSIgZD0iTTAgMGgyNHYyNEgweiIvPjxwYXRoIGQ9Ik0xMiAyYTEwIDEwIDAgMSAwIDEwIDEwQTEwLjAyOSAxMC4wMjkgMCAwIDAgMTIgMlptNC4yIDE0LjJMMTEgMTNWN2gxLjV2NS4ybDQuNSAyLjdaIiBzdHlsZT0iZmlsbDojZmZmO29wYWNpdHk6LjciLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_watch.svg
// module id = GXk1
// module chunks = 98